import { env } from '@/env'
import { parseVideo, type VideoInfo } from './video'

/**
 * A gallery is an ordered list of strings, as the API stores it: "media:<id>"
 * for an uploaded image, or a video link. One list keeps the order the owner
 * chose across images and videos.
 */
export type GalleryItem =
  | { kind: 'image'; key: string; mediaId: number; thumb: string; full: string }
  | { kind: 'video'; key: string; video: VideoInfo }

const MEDIA_PREFIX = 'media:'

export const mediaGalleryItem = (mediaId: number): string => `${MEDIA_PREFIX}${mediaId}`

export function parseGalleryItem(raw: string): GalleryItem | null {
  if (raw.startsWith(MEDIA_PREFIX)) {
    const mediaId = Number(raw.slice(MEDIA_PREFIX.length))
    if (!Number.isInteger(mediaId) || mediaId <= 0) return null
    return {
      kind: 'image',
      key: raw,
      mediaId,
      thumb: `${env.apiBaseUrl}/media/${mediaId}/display/landscape`,
      full: `${env.apiBaseUrl}/media/${mediaId}/display`,
    }
  }
  const video = parseVideo(raw)
  return video ? { kind: 'video', key: video.url, video } : null
}

export function parseGallery(items: readonly string[] | null | undefined): GalleryItem[] {
  return (items ?? []).map(parseGalleryItem).filter((item): item is GalleryItem => item !== null)
}

export const MAX_GALLERY_ITEMS = 20
